import { AnyMenuItem } from "../shared/types/menuItem";

export const getMenuItemUrl = (item: AnyMenuItem): string => {
	const now = new Date();
	if (item.previewUntil && new Date(item.previewUntil) > now) {
		if (!item.previewType) return `/countdown/${item.id}`;
		if (item.previewType !== "PAGE" && item.previewUrl) return item.previewUrl;
		if (item.previewBlock) return `/blocks/${item.previewBlock.slug}`;
	} else {
		if (item.type === "PAGE") return `/blocks/${item.block.slug}`;
		if (item.type === "CATEGORY") return "";
		return item.url;
	}
	throw "no preview url";
};
